export const DATE_FORMATS = {
  DATETIME_DISPLAY: 'MMM dd, yyyy h:mm a',
  DATETIME_INPUT: "yyyy-MM-dd'T'HH:mm",
  DATETIME_PARSE: 'yyyy-MM-dd HH:mm',
  DAY_ABBREV: 'EEE',
  DAY_NUMBER: 'd',
  DISPLAY: 'MMM dd, yyyy',
  INPUT: 'yyyy-MM-dd',
  ISO: "yyyy-MM-dd'T'HH:mm:ss'Z'",
  ISO_NO_TZ: "yyyy-MM-dd'T'HH:mm:ss",
  MONTH_ABBREV: 'MMM',
  MONTH_DAY: 'MMMM dd',
  MONTH_YEAR: 'MMMM yyyy',
  TIME_DISPLAY: 'h:mm a',
  TIME_DISPLAY_ZERO: 'hh:mm a',
  TIME_24H: 'HH:mm',
  YEAR_MONTH: 'yyyy-MM',
  YEAR_ONLY: 'yyyy',
} as const;
